import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import InspectionItem from '../InspectionItem'
import BookingTimes from '../../../../shared/components/BookingTimes'

class Deadline extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderContent = this.renderContent.bind(this)
  }

  renderContent () {
    return (
      <div>
        {<BookingTimes OrderId={this.props.order.Id} FromBody Component='OrderInspection' />}
      </div>
    )
  }

  render () {
    if (!this.props.deadline) return null
    let title = {
      icon: '/images/svgs/inspection/deadline.svg',
      text: '1232'
    }
    const headerClick = () => {
      let deadline = 'Deadline'
      if (this.props.isBodyshop) deadline = 'BodyshopDeadline'
      this.props.onHeaderClick(deadline)
    }
    return (
      <InspectionItem title={title} renderContent={this.renderContent} checked={this.props.deadline.Checked} onHeaderClick={headerClick} />
    )
  }
}

Deadline.defaultProps = {
  isBodyshop: false
}

Deadline.propTypes = {
  onDeadlineChange: PropTypes.func.isRequired,
  onChangeTime: PropTypes.func.isRequired,
  onHeaderClick: PropTypes.func.isRequired,
  isBodyshop: PropTypes.bool,
  order: PropTypes.object.isRequired
}

Deadline.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
})(Deadline)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/Deadline/index.js